
export class HolidayCalenderModelDto {
    id: number
    holidayName: string
    holidayDate: any
   


    constructor(

        id: number,
        holidayName: string,
        holidayDate:any
    ) {
        this.id = id
        this.holidayName = holidayName
        this.holidayDate=holidayDate
        

    }

}

export class HolidayCalenderModelDtoReq {
    data:HolidayCalenderModelDto[]
    user:string
constructor(
    data:HolidayCalenderModelDto[],
    user:string
){
this.data = data
this.user = user
}}
